import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';
import { CheckCircleOutline, Sync, SyncDisabled } from '@mui/icons-material';
import APIService from '../../api/apiService';
import RoutinesPopup from '../crops/Popup/RoutinesPopup';
import BasicAccordion from '../crops/utils/BasicAccordion';
import DisplayTable from '../utility/DisplayTable';
import { convertHoursToDaysAndHours, getTimezoneSansLocaleDate } from '../utility/constants';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';
import NoPermissionMsg from '../utility/NoPermissionMsg';


const tableTitles1 = [
  { title: 'State of Validate', key: 'state_name' },
  { title: 'Crop I.D', key: 'crop_id' },
  { title: 'Strain', key: 'strain' },
  { title: 'Event', key: 'routine_task_id' },
  { title: 'performed by', key: 'owner_names' },
  { title: 'Validated', key: 'is_validated' },
  { title: 'Sync to Metrc', key: 'sync_to_metrics' },
];

const tableTitles2 = [
  { title: 'State of Alert', key: 'state_name' },
  { title: 'Crop I.D', key: 'crop_id' },
  { title: 'Strain', key: 'strain' },
  { title: 'Routine/ Task I.D', key: 'routine_task_id' },
  { title: 'Subphase', key: 'subphase_name' },
  { title: 'performed by', key: 'owner_names' },
];

const tableTitles3 = [
  { title: 'State of Event', key: 'state_name' },
  { title: 'Crop I.D', key: 'crop_id' },
  { title: 'Strain', key: 'strain' },
  { title: 'Routine/ Task I.D', key: 'routine_task_id' },
  { title: 'Subphase', key: 'subphase_name' },
  { title: 'performed by', key: 'owner_names' },
];

const CommandView = ({ onClose, currDarkThemeClass, blah, commandViewParams }) => {
  // Alerts Table
  const [alertsData, setAlertsData] = useState([]);
  const [alertsCount, setAlertsCount] = useState(0);
  const [alertsPage, setAlertsPage] = useState(0);
  const [alertsPageSize, setAlertsPageSize] = useState(5);
  const [alertsSearchQuery, setAlertsSearchQuery] = useState('');

  // Validation Table
  const [validationData, setValidationData] = useState([]);
  const [validationCount, setValidationCount] = useState(0);
  const [validationPage, setValidationPage] = useState(0);
  const [validationPageSize, setValidationPageSize] = useState(5);
  const [validationSearchQuery, setValidationSearchQuery] = useState('');

  // Routines Table
  const [routinesData, setRoutinesData] = useState([]);
  const [routinesCount, setRoutinesCount] = useState(0);
  const [routinesPage, setRoutinesPage] = useState(0);
  const [routinesPageSize, setRoutinesPageSize] = useState(5);
  const [routinesSearchQuery, setRoutinesSearchQuery] = useState('');

  const [openRoutinePopup, setOpenRoutinePopup] = useState(false);
  const [save, setSave] = useState(false);
  const [selectedRoutine, setSelectedRoutine] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [assignees, setAssignees] = useState([]);
  const [isValidate, setIsValidate] = useState(false);
  const [validationFilter, setValidationFilter] = useState('not_validated');
  const [noPermission, setNoPermission] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false);

  const [expandedAccordions, setExpandedAccordions] = useState({
    validation: true,
    alert: true,
    event: true
  });

  const fetchCommandData = async ({ state, page, pageSize, setData, setCount, searchQuery = '', searchTerms = [], isValidate = null }) => {
    try {
      let url = `command-center/command-view-state-list/?page=${page + 1}&page_size=${pageSize}&state=${state}`;
      if (searchQuery && searchQuery.trim()) {
        url += `&search=${encodeURIComponent(searchQuery.trim())}`;
      }
      if (isValidate !== null) {
        url += `&is_validate=${isValidate}`;
      }
      const response = await APIService.fetchInstance(url)
      if (response?.data) {
        setData(response.data.results || []);
        setCount(response.data.count || 0);
      }
    } catch (error) {
      console.error(`Error fetching ${state} data:`, error);
    }
  };

  // const fetchAssignees = useCallback(async () => {
  //   try {
  //     const response = await APIService.fetchInstance('new/cropplan/');
  //     setAssignees(response.data.assignees);
  //   } catch (error) {
  //     console.error('Error fetching assignees:', error);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchAssignees();
  //   const handleEsc = event => {
  //     if (event.keycode === 27) {
  //       onclose();
  //     }
  //   };
  //   window.addEventListener('keydown', handleEsc);
  //   return () => window.removeEventListener('keydown', handleEsc);
  // }, []);

  useEffect(() => {
    if (!commandViewParams) return;

    if (commandViewParams.reset === true) {
      setValidationSearchQuery("");
      setAlertsSearchQuery("");
      setRoutinesSearchQuery("");
      setValidationPage(0);
      setAlertsPage(0);
      setRoutinesPage(0);
      setExpandedAccordions({
        validation: true,
        alert: true,
        event: true,
      });

      fetchCommandData({
        state: "validate",
        page: 0,
        pageSize: validationPageSize,
        setData: setValidationData,
        setCount: setValidationCount,
        searchQuery: "",
        isValidate: null,
      });

      fetchCommandData({
        state: "alert",
        page: 0,
        pageSize: alertsPageSize,
        setData: setAlertsData,
        setCount: setAlertsCount,
        searchQuery: "",
      });

      fetchCommandData({
        state: "event",
        page: 0,
        pageSize: routinesPageSize,
        setData: setRoutinesData,
        setCount: setRoutinesCount,
        searchQuery: "",
      });

      return;
    }

    if (commandViewParams.searchQuery) {
      if (commandViewParams.state === "alert") {
        setAlertsSearchQuery(commandViewParams.searchQuery);
        setAlertsPage(0);
        setExpandedAccordions({
          validation: false,
          alert: true,
          event: false,
        });
      } else if (commandViewParams.state === "event") {
        setRoutinesSearchQuery(commandViewParams.searchQuery);
        setRoutinesPage(0);
        setExpandedAccordions({
          validation: false,
          alert: false,
          event: true,
        });
      } else if (commandViewParams.state === "validate") {
        setValidationSearchQuery(commandViewParams.searchQuery);
        setValidationPage(0);
        setExpandedAccordions({
          validation: true,
          alert: false,
          event: false,
        });
      }
    }
  }, [commandViewParams]);

  const handleValidationFilterChange = useCallback((filterValue) => {
    const newFilterValue = validationFilter === 'include validated' ? 'not_validated' : 'include validated';
    setValidationFilter(newFilterValue);
    setValidationPage(0);
  }, [validationFilter]);

  const clickedState = commandViewParams?.state;
  const initialLoad = !clickedState;

  // VALIDATION FETCH
  useEffect(() => {
    if (isResetMode) {
      let isValidateParam = null;
      if (validationFilter === "not_validated") {
        isValidateParam = false;
      }

      fetchCommandData({
        state: "validate",
        page: validationPage,
        pageSize: validationPageSize,
        setCount: setValidationCount,
        setData: setValidationData,
        searchQuery: validationSearchQuery,
        isValidate: isValidateParam,
      });
      return;
    }

    if (clickedState && clickedState !== "validate") return;
    if (clickedState === "validate" && commandViewParams?.searchQuery && !validationSearchQuery) return;

    let isValidateParam = null;
    if (validationFilter === "not_validated") {
      isValidateParam = false;
    }

    fetchCommandData({
      state: "validate",
      page: validationPage,
      pageSize: validationPageSize,
      setCount: setValidationCount,
      setData: setValidationData,
      searchQuery: validationSearchQuery,
      isValidate: isValidateParam,
    });
  }, [
    clickedState,
    validationPage,
    validationPageSize,
    validationFilter,
    validationSearchQuery,
    isResetMode
  ]);

  // ALERTS FETCH
  useEffect(() => {
    if (clickedState && clickedState !== "alert") return;
    if (clickedState === "alert" && commandViewParams?.searchQuery && !alertsSearchQuery) return;

    fetchCommandData({
      state: "alert",
      page: alertsPage,
      pageSize: alertsPageSize,
      setCount: setAlertsCount,
      setData: setAlertsData,
      searchQuery: alertsSearchQuery,
    });
  }, [
    clickedState,
    alertsPage,
    alertsPageSize,
    alertsSearchQuery
  ]);

  // EVENTS FETCH
  useEffect(() => {
    if (clickedState && clickedState !== "event") return;
    if (clickedState === "event" && commandViewParams?.searchQuery && !routinesSearchQuery) return;

    fetchCommandData({
      state: "event",
      page: routinesPage,
      pageSize: routinesPageSize,
      setCount: setRoutinesCount,
      setData: setRoutinesData,
      searchQuery: routinesSearchQuery,
    });
  }, [
    clickedState,
    routinesPage,
    routinesPageSize,
    routinesSearchQuery
  ]);

  useEffect(() => {
    if (validationData.length > 0) {
      setIsValidate(validationData.map(item => item.is_validated === true));
    }
  }, [validationData])

  const handleChangePage1 = (event, newPage) => {
    setValidationPage(newPage);
  };

  const handleChangeRowsPerPage1 = event => {
    setValidationPageSize(parseInt(event.target.value, 10));
    setValidationPage(0);
  };

  const handleChangePage2 = (event, newPage) => {
    setRoutinesPage(newPage);
  };

  const handleChangeRowsPerPage2 = event => {
    setRoutinesPageSize(parseInt(event.target.value, 10));
    setRoutinesPage(0);
  };

  const handleChangePage3 = (event, newPage) => {
    setAlertsPage(newPage);
  };

  const handleChangeRowsPerPage3 = event => {
    setAlertsPageSize(parseInt(event.target.value, 10));
    setAlertsPage(0);
  };

  const handleValidationSearch = (searchQuery) => {
    setValidationSearchQuery(searchQuery);
    setValidationPage(0);
  };

  const handleAlertsSearch = (searchQuery) => {
    setAlertsSearchQuery(searchQuery);
    setAlertsPage(0);
  };

  const handleRoutinesSearch = (searchQuery) => {
    setRoutinesSearchQuery(searchQuery);
    setRoutinesPage(0);
  };

  const handleRoutineClick = async (id, index) => {
    try {
      const entity = `cropplan-routines/${id}/`;
      let response = await APIService.fetchInstance(entity);
      setSelectedRoutine(response.data);
      setSelectedRowIndex(index);
      setOpenRoutinePopup(true);
      setNoPermission(false);
    } catch (error) {
      console.error('Error fetching routine data:', error);
      if (error?.response?.status === 403) {
        setNoPermission(true);
      }
    }
  };

  const handleRoutinePopupClose = () => {
    setOpenRoutinePopup(false);
  };

  const handleSave = () => {
    setSave(false);
  };

  const [dataFromChild, setDataFromChild] = useState('');

  const handleDataFromChild = childData => {
    setDataFromChild(childData);
  };

  useEffect(() => {
    if (dataFromChild && 'rowIndex' in dataFromChild) {
      const index = dataFromChild['rowIndex'];
      const updatedData = [...validationData];
      updatedData[index] = {
        ...updatedData[index],
        ...dataFromChild,
      };
      setValidationData([...updatedData]);
      setIsValidate(updatedData.map(item => item.is_validated === true));
    }
  }, [dataFromChild]);

  const handleValidateClick = async (id, index) => {
    try {
      const response = await APIService.modifyInstance(`cropplan-routines/${id}/`, { is_validated: true });

      if (response.status === 200) {
        const newIsValidate = [...isValidate];
        newIsValidate[index] = true;
        setIsValidate(newIsValidate);
        const updatedValidationData = [...validationData];
        updatedValidationData[index] = {
          ...updatedValidationData[index],
          is_validated: true
        };
        setValidationData(updatedValidationData);
      }
    } catch (error) {
      console.error('Error validating routine:', error);
    }
  };

  const createTableEntries = (data = [], titles = []) =>
    data?.map((row, i) =>
      titles?.map((title, j) => {
        let val = row[title?.key];

        if (title?.key === 'crop_id') {
          const cropName = row?.['crop_name'];
          const route = `/crops/runs/${val}?tab=phases`;
          return (
            <Tooltip title={cropName} arrow>
              <Link
                to={route}
                style={{
                  color: currDarkThemeClass === 'dark-theme' ? '#f0f0f0' : '#242523',
                  textDecoration: 'underline',
                }}
              >
                {`C${val}`}
              </Link>
            </Tooltip>
          );
        }

        if (title?.key === 'routine_task_id') {
          const routineName = row?.['routine_name'];
          return (
            <Tooltip arrow>
              <span
                style={{ color: currDarkThemeClass === 'dark-theme' ? '#f0f0f0' : '#242523', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => handleRoutineClick(val, i)}
                title={routineName}
              >
                {`R${val} : ${routineName}`}
              </span>
            </Tooltip>
          );
        } else if (title?.key === 'started_on' || title?.key === 'ended_on') {
          return getTimezoneSansLocaleDate(val);
        } else if (title?.key === 'strain') {
          return <span>{val}</span>;
        } else if (title?.key === 'total_hours') {
          return convertHoursToDaysAndHours(val);
        } else if (title?.key === 'is_validated' && isValidate[i])
          return (
            <Typography style={{ display: 'flex', alignItems: 'center' }}>
              <CheckCircleOutline style={{ color: '#B1D23A', marginRight: '5px' }} />
              <span style={{ color: '#B1D23A' }}>Validated</span>
            </Typography>
          );
        else if (title?.key === 'is_validated') {
          return (
            <Button
              style={{
                border: '2px solid #B1D23A',
                color: '#B1D23A',
                backgroundColor: 'transparent',
                fontSize: '13px',
                padding: '2px 25px',
                borderRadius: '0px',
                textTransform: 'none',
              }}
              onClick={() => handleRoutineClick(row['routine_task_id'], i)}
            >
              Validate Now
            </Button>
          );
        } else if (title?.key === 'sync_to_metrics') {
          return (
            <Typography style={{ display: 'flex', alignItems: 'center' }}>
              {val === 'Synced' ? (
                <>
                  <CheckCircleOutline style={{ color: '#B1D23A', marginRight: '5px' }} />
                  <span style={{ color: '#B1D23A' }}>{val}</span>
                </>
              ) : val === 'Syncing...' ? (
                <>
                  <Sync style={{ color: 'orange', marginRight: '5px' }} />
                  <span style={{ color: '#B1D23A' }}>{val}</span>
                </>
              ) : (
                <>
                  <SyncDisabled style={{ color: 'orange', marginRight: '5px' }} />
                  <span>{val}</span>
                </>
              )}
            </Typography>
          );
        } else return val;
      })
    );

  const validationFilterOptions = [
    {
      value: 'include validated',
      label: 'Include Validated',
      color: '#e0e0e0',
      textColor: '#000000',
      hoverColor: '#bdbdbd'
    },
  ];

  const cvSVTableProps = {
    currDarkThemeClass,
    emptyTableMsg: 'No State Validation',
    toShowAddBtn: false,
    tableTitles: tableTitles1,
    tableEntries: createTableEntries(validationData, tableTitles1),
    count: validationCount,
    page: validationPage,
    rowsPerPage: validationPageSize,
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    handleChangePage: handleChangePage1,
    handleChangeRowsPerPage: handleChangeRowsPerPage1,
    showSearch: true,
    onSearch: handleValidationSearch,
    useBackendSearch: true,
    enableMultiTermSearch: true,
    key: validationSearchQuery,
    initialSearchTerms: validationSearchQuery ? [validationSearchQuery] : [],
    showFilterChips: true,
    filterOptions: validationFilterOptions,
    activeFilter: validationFilter,
    onFilterChange: handleValidationFilterChange,
    sx: {
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '6px 12px',
      },
      '& .MuiTableRow-root': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      },
    },
  };

  const cvSATableProps = {
    currDarkThemeClass,
    emptyTableMsg: 'No State Alerts',
    toShowAddBtn: false,
    tableTitles: tableTitles2,
    tableEntries: createTableEntries(alertsData, tableTitles2),
    count: alertsCount,
    page: alertsPage,
    rowsPerPage: alertsPageSize,
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    handleChangePage: handleChangePage3,
    handleChangeRowsPerPage: handleChangeRowsPerPage3,
    showSearch: true,
    onSearch: handleAlertsSearch,
    useBackendSearch: true,
    enableMultiTermSearch: true,
    key: alertsSearchQuery,
    initialSearchTerms: alertsSearchQuery ? [alertsSearchQuery] : [],
    sx: {
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '6px 12px',
      },
      '& .MuiTableRow-root': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      },
    },
  };

  const cvSETableProps = {
    currDarkThemeClass,
    emptyTableMsg: 'No State Events',
    toShowAddBtn: false,
    tableTitles: tableTitles3,
    tableEntries: createTableEntries(routinesData, tableTitles3),
    count: routinesCount,
    page: routinesPage,
    rowsPerPage: routinesPageSize,
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    handleChangePage: handleChangePage2,
    handleChangeRowsPerPage: handleChangeRowsPerPage2,
    showSearch: true,
    onSearch: handleRoutinesSearch,
    useBackendSearch: true,
    enableMultiTermSearch: true,
    key: routinesSearchQuery,
    initialSearchTerms: routinesSearchQuery ? [routinesSearchQuery] : [],
    sx: {
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '6px 12px',
      },
      '& .MuiTableRow-root': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      },
    },
  };

  const handleLocalReset = () => {
    setIsResetMode(true);
    setValidationSearchQuery("");
    setAlertsSearchQuery("");
    setRoutinesSearchQuery("");
    setValidationPage(0);
    setAlertsPage(0);
    setRoutinesPage(0);
    setValidationFilter('not_validated');
    setIsValidate(false);
    setExpandedAccordions({
      validation: true,
      alert: true,
      event: true,
    });

    fetchCommandData({
      state: "validate",
      page: 0,
      pageSize: validationPageSize,
      setData: setValidationData,
      setCount: setValidationCount,
      searchQuery: "",
      isValidate: false,
    });

    fetchCommandData({
      state: "alert",
      page: 0,
      pageSize: alertsPageSize,
      setData: setAlertsData,
      setCount: setAlertsCount,
      searchQuery: "",
    });

    fetchCommandData({
      state: "event",
      page: 0,
      pageSize: routinesPageSize,
      setData: setRoutinesData,
      setCount: setRoutinesCount,
      searchQuery: "",
    });
  };

  return (
    <Box className={"command-center-view"} >
      {noPermission && (
        <NoPermissionMsg
          action="validate"
          entity="this routine"
          onClose={() => setNoPermission(false)}
        />
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: "10px"
        }}
      >
        <Button
          onClick={handleLocalReset}
          sx={{
            backgroundColor: "#414437",
            color: "#FFF",
            borderRadius: "6px",
            padding: "6px 14px",
            fontSize: "14px",
            textTransform: "none",
            '&:hover': { backgroundColor: "#555" }
          }}
        >
          Reset Search
        </Button>
      </Box>

      <BasicAccordion
        title={
          <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
            State of Validation (Total Count : {validationCount})
          </Typography>
        }
        currDarkThemeClass={currDarkThemeClass}
        expanded={expandedAccordions.validation}
        onChange={(event, isExpanded) => {
          setExpandedAccordions(prev => ({ ...prev, validation: isExpanded }));
        }}
        accordionCustomProps={{
          style: { marginBottom: '6px', backgroundColor: currDarkThemeClass === 'dark-theme' ? '#242523' : '#E6F1C1', padding: '1px 5px' },
        }}
      >
        <DisplayTable {...cvSVTableProps} />
      </BasicAccordion>

      <BasicAccordion
        title={
          <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
            State of Alerts (Total Count : {alertsCount})
          </Typography>
        }
        currDarkThemeClass={currDarkThemeClass}
        expanded={expandedAccordions.alert}
        onChange={(event, isExpanded) => {
          setExpandedAccordions(prev => ({ ...prev, alert: isExpanded }));
        }}
        accordionCustomProps={{
          style: { marginBottom: '6px', backgroundColor: currDarkThemeClass === 'dark-theme' ? '#242523' : '#E6F1C1', padding: '1px 5px' },
        }}
      >
        <DisplayTable {...cvSATableProps} />
      </BasicAccordion>

      <BasicAccordion
        title={
          <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
            State of Event (Total Count : {routinesCount})
          </Typography>
        }
        currDarkThemeClass={currDarkThemeClass}
        expanded={expandedAccordions.event}
        onChange={(event, isExpanded) => {
          setExpandedAccordions(prev => ({ ...prev, event: isExpanded }));
        }}
        accordionCustomProps={{
          style: { marginBottom: '6px', backgroundColor: currDarkThemeClass === 'dark-theme' ? '#242523' : '#E6F1C1', padding: '1px 5px' },
        }}
      >
        <DisplayTable {...cvSETableProps} />
      </BasicAccordion>

      {openRoutinePopup && (
        <RoutinesPopup
          rowIndex={selectedRowIndex}
          routine={selectedRoutine}
          subphase={selectedRoutine.subphase}
          cropplanid={selectedRoutine.cropplanid}
          handleRoutinesPopupSave={null}
          assignees={assignees}
          currDarkThemeClass={currDarkThemeClass}
          onClose={handleRoutinePopupClose}
          open={openRoutinePopup}
          handleSave={handleRoutineClick}
          sendDataToParent={handleDataFromChild}
        />
      )}
    </Box>
  );
};

export default CommandView;